import { DocumentApi } from 'Api/Document/DocumentApi';
import { Button } from 'Components/Buttons/Buttons';
import { useCachedData } from 'Components/Context/CachedDataContext';
import { Modal } from 'Components/Modal/Modal';
import { ICON_CLOSE } from 'Config/Icons';
import { iso8601ToUsDateShort } from 'Helpers/DateTimeUtils/DateTimeUtils';
import { UserNameFormat, getUserNameFromSubject } from 'Helpers/UserUtils';
import { ExceptionHistoryResponse } from 'Models/Exceptions';

import { ExceptionDetailsSnapshot } from '../ExceptionDetailsSnapshot/ExceptionDetailsSnapshot';

export interface ExceptionHistoryModalProps {
    history: ExceptionHistoryResponse;
    documentApi: DocumentApi;
    hideModal: () => void;
}

/**
 * Renders a modal that displays a detailed historical snapshot of an exception. Matches the "main" section (containing current information) of the Exception Details page. Does not include information about impacted controls or third parties.
 */
export const ExceptionHistoryModal = (props: ExceptionHistoryModalProps) => {
    const cachedData = useCachedData();

    return (
        <Modal open header={props.history.exception.title} subHeader={`Last updated: ${iso8601ToUsDateShort(props.history.exception.last_updated_timestamp)} by ${getUserNameFromSubject(props.history.exception.last_updated_by, cachedData.users, UserNameFormat.FIRST_SPACE_LAST)}`}>
            <ExceptionDetailsSnapshot documentApi={props.documentApi} exceptionHistoryResponse={props.history} type="historical" />
            <div className={'modalFormButtonContainer'}>
                <Button variant="secondary" onClick={props.hideModal} fontAwesomeImage={ICON_CLOSE}>
                    Close
                </Button>
            </div>
        </Modal>
    );
};
